import React, { useRef, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDelete } from "react-icons/md";
import { IoDownloadOutline } from "react-icons/io5";
import { deleteAttachment } from "../../apiCall";
import toast from "react-hot-toast";
import { ConfirmationModal } from "../Modals/ConfirmationModal";
import { useParams } from "react-router-dom";
import { IoMdSearch } from "react-icons/io";
import { FaDownload } from "react-icons/fa6";
import { useStateValue } from "../../StateProvider";

const Attachments = ({
  filteredData,
  refetch,
  setActiveTab,
  setTab,
  handleSearch,
  searchInput,
  setAttachmentCount,
  currentPage,
  handlePageChange,
  totalPages,
  currentItems,
  setEditAttchmentId,
  attchmentId,
  setAttchmentId,
  isLoading,
  // removeSelection,
}) => {
  const removeAttachment = async (id) => {
    // Perform the API call to fetch company info
    try {
      const response = await deleteAttachment(id);
      if (response?.status === 200) {
        toast.success(response.data.status);
        setAttachmentCount((prevCount) => prevCount - 1);
        refetch();
      } else if(response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };
  const downloadFile = (fileName, fileData, mimeType) => {
    const link = document.createElement("a");
    link.href = `data:${mimeType};base64,${fileData}`;
    link.download = fileName;
    link.click();
  };
  const [{ sysConfig }, dispatch] = useStateValue();

  const [confirmationShow, setConfirmationShow] = useState(false);
  const [funHandler, setFunHandler] = useState();
  const [changeUserFilter, setChangeUserFilter] = useState(true);

  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };
  const handleConfirmationShow = () => setConfirmationShow(true);
  const removeSelection = () => {
    setAttchmentId("");
  };

  return (
    <div className="attechments-card">
      <div className="card mb-5 ">
        <div className="card-header mt-4 d-flex flex-column justify-content-between">
          <div className=" row d-flex justify-content-between ">
            <div className=" col-lg-6 col-md-7 d-flex mb-4">
              <input
                ref={searchInput}
                type="search"
                className="form-control "
                // value={searchQuery}
                onChange={(e) => {
                  if (e.target.value === "") {
                    handleSearch();
                  }
                }}
                placeholder="Search for Name & Description."
              />
              <div
                className="btn btn-primary ms-3"
                onClick={() => handleSearch()}
              >
                <IoMdSearch size={25} />
              </div>
            </div>
            <div
              className="btn btn-primary  d-flex align-items-center justify-content-center col-lg-2 col-md-4 co-12 mb-4 "
              onClick={() => setActiveTab("addAttachment")}
            >
              Add Attachment
            </div>
          </div>
        </div>
        <div className="card-body">
          {isLoading && (
            <div className="m-5 fs-3">
              <strong>Fetching records..</strong>
            </div>
          )}
          {!isLoading && (
            <div>
              {currentItems.length > 0 ? (
                <>
                  {currentItems.map((item) => (
                    <div className="card card-bordered  mb-4 ">
                      {console.log(
                        parseInt(attchmentId) === item?.ID,
                        attchmentId,
                        item?.ID
                      )}
                      <div
                        className={` p-3 text-start ${
                          parseInt(attchmentId) === item?.ID
                            ? "bg-primary-op"
                            : ""
                        }`}
                      >
                        <div className="d-flex justify-content-between">
                          <div className="d-flex align-items-center">
                            {/* <img
                          src="../assets/images/background/profile-bg.jpg"
                          alt=""
                          className="icon-shape icon-xxl rounded-3"
                        /> */}
                            <div className="ms-3">
                              <h4 className="mb-0">
                                <div className="truncate-1">{item.DocNm}</div>
                              </h4>
                              <div className="truncate">
                                <small>{item.Dscr}</small>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center">
                            <div
                              className="btn btn-ghost btn-icon btn-sm rounded-circle texttooltip"
                              data-template="editOne"
                              onClick={() => {
                                setEditAttchmentId(item.ID);
                                setActiveTab("addAttachment");
                              }}
                            >
                              <FaRegEdit
                                size={20}
                                style={{ fill: "#624bff" }}
                              />
                              <div id="editOne" className="d-none">
                                <span>Edit</span>
                              </div>
                            </div>
                            <div
                              className="btn btn-ghost btn-icon btn-sm rounded-circle texttooltip"
                              data-template="trashOne"
                              onClick={() => {
                                handleConfirmationShow();
                                setFunHandler({
                                  fun: removeAttachment,
                                  id: item.ID,
                                  title: "delete attachment",
                                });
                              }}
                            >
                              <MdOutlineDelete
                                size={22}
                                style={{ fill: "#d2042dc7" }}
                              />
                            </div>
                            <div
                              className="btn btn-ghost btn-icon btn-sm rounded-circle texttooltip"
                              data-template="trashOne"
                              onClick={() =>
                                downloadFile(
                                  item.FileNm,
                                  item.Attchment,
                                  item.MimeType
                                )
                              }
                            >
                              <FaDownload
                                size={20}
                                style={{ fill: "#624bff" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="div"></div>
                    </div>
                  ))}
                </>
              ) : (
                <div className="m-5 fs-3">
                  <strong>No records found..!</strong>
                </div>
              )}
            </div>
          )}
          {filteredData.length > 0 && (
            <div className="card-footer d-md-flex justify-content-between align-items-center">
              <span>
                Showing{" "}
                {currentPage * Number(sysConfig["Rows in MultiLine List"]) -
                  Number(sysConfig["Rows in MultiLine List"]) +
                  1}{" "}
                to{" "}
                {currentPage * Number(sysConfig["Rows in MultiLine List"]) >=
                filteredData.length
                  ? filteredData.length
                  : currentPage *
                    Number(sysConfig["Rows in MultiLine List"])}{" "}
                of {filteredData.length} entries
              </span>
              <nav className="mt-2 mt-md-0">
                <ul className="pagination mb-0 ">
                  <li
                     className="page-item "
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (currentPage > 1) {
                        handlePageChange(currentPage - 1);
                        removeSelection();
                      }
                    }}
                  >
                    <div
                      className={`page-link ${
                        currentPage === 1 ? "disabled" : ""
                      } `}
                    >
                      Previous
                    </div>
                  </li>
                  {Array(totalPages ? totalPages : 0)
                    .fill()
                    .map((item, index) => (
                      <li
                        style={{ cursor: "pointer" }}
                        className={`${
                          currentPage === index + 1
                            ? "page-item active"
                            : "page-item"
                        } ${
                          currentPage + 2 >= index + 1 &&
                          index + 1 > currentPage - 2
                            ? // currentPage - 2 < index + 1
                              "d-block"
                            : "d-none"
                        }`}
                        onClick={() => {
                          handlePageChange(index + 1);
                          removeSelection();
                        }}
                      >
                        <div className="page-link">{index + 1}</div>
                      </li>
                    ))}

                  <li className="page-item">
                    <div
                      style={{ cursor: "pointer" }}
                      className={`page-link ${
                        totalPages === currentPage ? "disabled" : ""
                      } `}
                      onClick={() => {
                        if (totalPages > currentPage) {
                          removeSelection();
                          handlePageChange(currentPage + 1);
                        }
                      }}
                    >
                      Next
                    </div>
                  </li>
                </ul>
              </nav>
            </div>
          )}
          <div></div>

          <div className="d-flex justify-content-end">
            <div
              className="btn btn-outline-danger col-md-2 col-12 "
              style={{ height: "fit-content" }}
              onClick={() => setTab("information")}
            >
              Back
            </div>
          </div>
        </div>
      </div>

      <ConfirmationModal
        show={confirmationShow}
        onHide={handleConfirmationClose} 
        funHandler={funHandler}
      />
    </div>
  );
};

export default Attachments;
